import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/services/notification.service';
import { CourseService } from 'src/app/services/course.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-pending-recordings',
  templateUrl: './pending-recordings.component.html',
  styleUrls: ['./pending-recordings.component.scss']
})
export class PendingRecordingsComponent implements OnInit {
  private modalRef;
  constructor(private modalService: NgbModal,
    private course_service: CourseService,
    private fb: FormBuilder,
    private ns: NotificationService) { }
  Video_url: any = '';
  @Input() recordings: any = [];
  @Input() Edittopics: any = [];
  @Input() course_id: any;
  @Output() recording_saved = new EventEmitter();

  _topic_details: any[] = [];
  recordings_index;

  _topic_index;

  pending_recording_form: FormGroup;
  recording_form_session: FormGroup;
  topic_index_session;

  submitAddCourse = false;
  ngOnInit() {
    this.validateForm();
  }

  validateForm(): void {
    this.pending_recording_form = this.fb.group({
      topics: this.fb.array([this.createTopic('')]),
    });

    this.recording_form_session = this.fb.group({
      sessions: this.fb.array([this.createArray('session', '')])
    })
    if (this.pending_recording_form) {
      this.removeArray('topics', 0, 0);
    }

  }

  createTopic(value): FormGroup {
    let topic_title = '';
    let topic_des = '';
    let id = '';

    if (value) {
      topic_title = value.title;
      topic_des = value.description;
      id = value._id;
    }
    this.submitAddCourse = false;
    return this.fb.group({
      title: [topic_title, Validators.required],
      description: [topic_des, Validators.required],
      _id: [id],
      sessions: this.fb.array([this.createArray('session', value.sessions)])
    })
  }

  createArray(type, session_value) {
    let title = '';
    let des = '';
    let url = '';
    if (session_value) {
      title = session_value.title;
      des = session_value.description;
      url = session_value.url;
    }
    this.submitAddCourse = false;
    if (type == 'session') {
      return this.fb.group({
        title: [title, Validators.required],
        description: [des, Validators.required],
        url: [url],
        key: ['session'],
        _id: [""],
      });
    }
  }

  removeArray(controlName: string, index: number, controlIndex: number, type?: string) {
    if (type == 'manual') {
      if (confirm('Are you sure want to delete ' + controlName)) {
        this.remove_value(controlName, index, controlIndex);
      } else {
        return
      }
    } else {
      this.remove_value(controlName, index, controlIndex);
    }

  }

  remove_value(controlName, index, controlIndex) {
    let control;
    let deleteIndex;
    if (controlName == 'topics') {
      control = <FormArray>this.pending_recording_form.controls[controlName];
      deleteIndex = index;
    } else if (controlName == 'sessions') {
      control = <FormArray>this.pending_recording_form.get('topics')['controls'][index].controls[controlName]
      deleteIndex = controlIndex;
    }
    control.removeAt(deleteIndex);
  }



  add_topic_session(value, index, session_value) {
    let values;

    if (value != undefined) {
      values = value;
      value = 'select'
    } else {
      values = value;
    }

    this.submitAddCourse = false;
    let topic = this.pending_recording_form.get('topics') as FormArray;
    if (values == 'topics') {
      topic.push(this.createTopic(session_value));
    } else if (values == 'session') {
      topic.controls[index]['controls'].sessions.push(this.createArray('session', session_value));
    }
  }


  openRecord(videoIframe, url) {
    this.Video_url = url;
    this.modalRef = this.modalService.open(videoIframe, { size: 'md' });
  }


  get_date(date, type) {
    let my_date;
    if (date && type == 'Date') {
      my_date = date.split('T')[0];
      return my_date
    } else if (date && type == 'Time') {
      my_date = date.slice(11, 16);
      return my_date + ' (IST)';
    }
    else {
      return 'No date  found';
    }

  }

  Get_status(status) {
    if (status == ('recorded' || 'zoom_recorded')) {
      return true;
    } else {
      return false;
    }
  }
  get_topic(event, recording_index, topic_popup) {
    if (event.target.value == 'select') {
      return;
    }
    this.recordings_index = recording_index;
    if (event.target.value == 'create_topic') {
      this.modalRef = this.modalService.open(topic_popup);
      this.add_topic_session('topics', this.pending_recording_form.value.topics.length, '');
      event.target.value = 'select'
      return;
    }

    this._topic_index = event.target.value;
    this._topic_details = this.Edittopics[this._topic_index];
  }

  add_session(create_session_topic, recordings_index) {
    if (this.recordings_index != recordings_index) {
      this.ns.showNotification('info', 'First select topic from drop down then create session');
      return;
    }
    this.modalRef = this.modalService.open(create_session_topic);
  }
  reset_topic() {
    this.pending_recording_form.reset();
    this.recording_form_session.reset();
    this.remove_value('topics', 0, 0);
    this._topic_details = [];
    this.recordings_index = null;
    // this.topics = [];
    this._topic_index = null;
    this.topic_index_session = null;
    this.submitAddCourse = false;
  }

  save_topic(type, index = null) {
    if (type == "topic") {
      if (this.pending_recording_form.invalid) {
        this.ns.showNotification('info', 'Please Add title and description');
        return;
      }
      this.pending_recording_form.controls.topics['controls'][this.topic_index_session].controls.sessions.controls[0].controls.url.setValue(this.recordings[this.recordings_index].s3_path)
      let topic = this.pending_recording_form.value.topics;
      this.Edittopics.push(topic[this.topic_index_session]);
      this.save_recording();
      this.modalRef.close();
    }
  }

  get_index(index) {
    this.topic_index_session = index;
  }
  save_session_in_topic() {

    if (this.recording_form_session.invalid) {
      this.ns.showNotification('info', 'Please Add session title and description');
      return;
    }
    let session_value;
    let edit_topic = this.Edittopics[this._topic_index];
    let pending_topic = this.pending_recording_form.value.topics;
    let get_topic = pending_topic.find(topic => topic.title == edit_topic.title)

    if (get_topic) {

      if (get_topic.sessions[this.topic_index_session].url == this.recordings[this.recordings_index].s3_path) {
        this.ns.showNotification('info', 'Your Path already saved if you want to set again do rest');
        return;
      }
    }
    if (get_topic && get_topic.title != '') {
      let pending_recording_index = pending_topic.findIndex(topic => topic.title == edit_topic.title);
      let session_index = this.Edittopics[this._topic_index].sessions.length;
      session_value = {
        title: this.recording_form_session.value.sessions[0].title,
        description: this.recording_form_session.value.sessions[0].description,
        url: this.recordings[this.recordings_index].s3_path,
        key: 'session',
        _id: ''
      }
      this.add_topic_session('session', pending_recording_index, session_value);

    } else if (get_topic == undefined) {
      let topic_values = {
        title: edit_topic.title,
        description: edit_topic.description,
        _id: edit_topic._id,
        sessions: {
          title: this.recording_form_session.value.sessions[0].title,
          description: this.recording_form_session.value.sessions[0].description,
          url: this.recordings[this.recordings_index].s3_path,
          key: 'session',
          _id: ''
        }
      }
      this.add_topic_session('topics', this.pending_recording_form.value.topics.length, topic_values);
    }
    this.save_recording();
    this.modalRef.close();
    return;
  }

  save_recording() {
    if (this.pending_recording_form.value.length == 0) {
      this.ns.showNotification('info', 'Please select any recored video then save it!.');
      return;
    }

    this.course_service.save_zoom_recording(this.pending_recording_form.value, this.course_id).subscribe(get_status => {
      this.ns.showNotification('success', get_status.message);
      this.recording_saved.emit('saved_recording');
      this.reset_topic();
      return;
    },
      (err) => {
        this.ns.showNotification('error', err.message);
        return;
      });
  }

  close_popup(close, type) {
    if (type == 'topic') {
      let pending_topic = this.pending_recording_form.value.topics;
      let pending_recording_index = pending_topic.findIndex(topic => topic.title == '');

      if (pending_recording_index > -1) {
        this.remove_value('topics', pending_recording_index, 0);
      }

      pending_recording_index = pending_topic.findIndex(topic => topic.description == '');
      if (pending_recording_index > -1) {
        this.remove_value('topics', pending_recording_index, 0);
      }
    }
    this.modalRef.close();

  }

  get_session(index) {
    let topics = this.pending_recording_form.value.topics;
    let r;
    if (this.pending_recording_form.value.topics.length > 0) {
      r = topics.find(pr => pr.sessions[0].url == this.recordings[index].s3_path);
    }

    if (r && r.url != '') {
      return false;
    }

    return true;
  }
}
